import React from 'react';
import { getEvents, EventStatus } from '../../../model/event';
import { useData, usePaginatedResponse } from '../../../model/data';
import { Container } from '../../../components/Container/Container';
import { Card } from '../../../components/Card/Card';
import { Pagination } from '../../../components/Pagination/Pagination';
import { serializeQuery } from '../../../model/filter';
import { useMeta } from '../../../model/meta';
import { useQueryAsState } from '../../../model/history';
import { EventsList } from './EventsList';
import { t } from '../../../locales/translate';
import './Events.css';
import { compact } from 'lodash';
import { PaginatedPermissionButton } from '../../../components/Button/PaginatedPermissionButton';
import { useModalPresenter } from '../../../components/Modal/PresentedModal';
import { CreateEvent } from './create/create';

export function Events(): JSX.Element {
  const [params] = useQueryAsState();
  const modal = useModalPresenter();

  const paginator = usePaginatedResponse(
    (page, perPage) =>
      getEvents({
        term: serializeQuery(params.query),
        page,
        perPage,
        status: params.status as EventStatus[],
        timeframe: params.timeframe || undefined,
        sortBy: params.sortBy,
        sortDir: params.sortDir,
      }),
    serializeQuery(params.query) + JSON.stringify(params)
  );

  useMeta({
    title: t.model.event._plural,
  });

  const events = useData((db) => compact(paginator.currentIds.map((e) => db.table('events').find(e))));

  return (
    <Container className="events">
      <Card
        title={t.model.event._plural}
        elevation={2}
        actions={
          <PaginatedPermissionButton
            name="plus"
            onClick={() => modal.present(CreateEvent, {}, { size: 'small' })}
            model={paginator}
            permission="create"
          />
        }
        pagination={<Pagination {...paginator} />}
        fullbleed
      >
        <EventsList events={events} error={paginator.error} loading={paginator.loading}></EventsList>
      </Card>
    </Container>
  );
}
